module.exports = __webpack_public_path__ + "static/media/arrow-down.5ecea90d.svg";